import { useEffect, useState } from "react";
import { useDynamicData } from "~/common/hooks/useDynamicData";
import { InternalNotesRecentUpdateResult } from "../../ProductDetailPageResult";
import { defaultInternalNotesData } from "../InternalNotesButton";
import { updateRecentInternalNotes } from "../requests";

export function useRecentInternalNotesUpdate(
  itemNumber: string,
  isInternal: boolean,
) {
  const [recentUpdate, setRecentUpdate] =
    useState<InternalNotesRecentUpdateResult>(defaultInternalNotesData);

  const isInitialized = useDynamicData();

  useEffect(() => {
    async function fetchUpdate() {
      const result = await updateRecentInternalNotes(itemNumber);
      if (!result.isError && result.value) {
        setRecentUpdate(result.value);
      } else {
        setRecentUpdate(defaultInternalNotesData);
      }
    }
    if (isInternal && isInitialized) {
      fetchUpdate();
    }
  }, [itemNumber, isInternal, isInitialized]);

  return recentUpdate;
}
